import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { KeycloakData } from '@/shared/types/global.types'

export function getKeycloakData(token: string): Promise<KeycloakData> {
  return apiRequest<KeycloakData>(API_PATH.KEYCLOAK, token)
}
